import SummaryCardComponent from "./SummaryCard.Component";

export default SummaryCardComponent;
